module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1222"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1222"
    },
    "bundlingPackage": "EmailUnsubscribeUI",
    "bundlingPackageVersion": "static-1.11425",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};